module.exports = __webpack_public_path__ + "img/privacy_by_default.c6f1ceea.png";